// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-reader-modal-buttonsContainer--2axbynJgUWJ2yXIsSLhF99{display:flex;justify-content:flex-end}", "",{"version":3,"sources":["webpack://src/components/devicecontrol/DigiTrac/ReaderModal/ReaderModal.module.scss"],"names":[],"mappings":"AAAA,wDACC,YAAA,CACA,wBAAA","sourcesContent":[".buttonsContainer {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonsContainer": "-reader-modal-buttonsContainer--2axbynJgUWJ2yXIsSLhF99"
};
export default ___CSS_LOADER_EXPORT___;
